var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask",on:{"click":_vm.closeShareMask}},[_c('img',{attrs:{"src":require("../assets/share.png"),"alt":"","srcset":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }